export default {
  alert: {
    defaultProps: {
      className: 'font-bebasneue text-xl tracking-wide border-2 border-black bg-yellow'
    },
    styles: {
      base: {
        alert: {
          borderRadius: ''
        }
      }
    }
  },
  chip: {
    defaultProps: {
      className: 'font-bebasneue text-lg tracking-wide border-2 border-black font-normal'
    },
    styles: {
      base: {
        chip: {
          textTransform: 'none'
        }
      },
      sizes: {
        sm: {
          chip: {
            borderRadius: ''
          }
        },
        md: {
          chip: {
            borderRadius: ''
          }
        },
        lg: {
          chip: {
            borderRadius: ''
          }
        }
      }
    }
  },
  button: {
    styles: {
      base: {
        initial: {
          textTransform: 'none'
        }
      },
      sizes: {
        sm: {
          borderRadius: ''
        },
        md: {
          borderRadius: ''
        },
        lg: {
          borderRadius: ''
        },
      }
    }
  },
  dialog: {
    styles: {
      base: {
        container: {
          borderRadius: ''
        }
      }
    }
  },
  dialogHeader: {
    defaultProps: {
      className: 'justify-center'
    }
  },
  dialogBody: {
    defaultProps: {
      className: 'text-center'
    }
  },
  dialogFooter: {
    styles: {
      base: {
        justifyContent: 'justify-center'
      }
    }
  },
  tooltip: {
    defaultProps: {
      className: 'border-dark border-2 hover:bg-dark hover:text-yellow hover:border-yellow font-minion'
    },
    styles: {
      base: {
        bg: 'bg-yellow',
        borderRadius: '',
        color: 'text-dark'
      }
    }
  },
};
